import React, { useEffect } from 'react';
import {
  ComponentAlign,
  ComponentPadding,
  ComponentSize,
  Container,
  FieldViewLogo,
  LogoType,
  Orientation,
  Typography,
  TypographyVariant,
} from '@tcc/fds';
import { getMessage } from '@tcc/i18n';
import styles from './unverifiedBlocker.css';

interface UnverifiedBlockerProps {
  onLogout: () => void;
  timeout: number;
}

export const UnverifiedBlocker = ({
  onLogout,
  timeout,
}: UnverifiedBlockerProps) => {
  useEffect(() => {
    const instance = setTimeout(onLogout, timeout);
    return () => clearTimeout(instance);
  }, [onLogout, timeout]);

  return (
    <div data-test-id='unverified-blocker-container' className={styles.unverifiedBlocker}>
      <Container
        className={styles.card}
        orientation={Orientation.Vertical}
        align={ComponentAlign.Center}
        width='360px'
        padding={ComponentPadding.Container}
      >
        <FieldViewLogo
          type={LogoType.COLORED}
          size={ComponentSize.Lg}
          testId='unverified-blocker-logo'
        />
        <Typography variant={TypographyVariant.Subheading} testId='unverified-blocker-title'>
          {getMessage('pluginLoad.error')}
        </Typography>
        <Typography variant={TypographyVariant.Body} testId='unverified-message'>
          {getMessage('general.unverifiedAccountError')}
        </Typography>
      </Container>
    </div>
  );
};
